import { render, staticRenderFns } from "./BasePagingTable.vue?vue&type=template&id=c7771ff2&scoped=true&"
import script from "./BasePagingTable.vue?vue&type=script&lang=js&"
export * from "./BasePagingTable.vue?vue&type=script&lang=js&"
import style0 from "./BasePagingTable.vue?vue&type=style&index=0&id=c7771ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7771ff2",
  null
  
)

export default component.exports